import "./HeroSection.css";

import Header from "../Header/Header";
import SearchBar from "../SearchBar/SearchBar";
import BannerSlider from "../BannerSlider/BannerSlider";

function HeroSection({ banners }) {

    return (

        <section className="hero-section">

            {/* Decorative Shapes */}

            <div className="hero-circle hero-circle-1"></div>

            <div className="hero-circle hero-circle-2"></div>

            <div className="hero-circle hero-circle-3"></div>

            <div className="hero-circle hero-circle-4"></div>

            {/* Floating Icons */}

            <span className="hero-food burger">
                🍔
            </span>

            <span className="hero-food pizza">
                🍕
            </span>

            <span className="hero-food bowl">
                🥘
            </span>

            <span className="hero-food spoon">
                🥄
            </span>

            {/* Header */}

            <Header />

            {/* Search */}

            <div className="hero-search">

                <SearchBar />

            </div>

            {/* Banner */}

            <div className="hero-banner">

                <BannerSlider
                    banners={banners}
                />

            </div>

        </section>

    );

}

export default HeroSection;